export default __webpack_public_path__ + "static/media/trr-food-pastry-1.b7e6bfac.png";